const pasteTree = async (map, nodes, insert) => {
    const data = await map.actions.readTreeFromClipboard()
    const nodesToSelect = new Set()

    await Promise.all(
        nodes.map(async node => Promise.all(
            data.trees.map(async tree => {
                const n = map.importTree(tree)
                map.BizNode.AR.castFrom(map, n)
                insert(node, n)
                const _n = map.nodeProxy(n)
                await _n.emitEventUp({type: 'attach'})

                if (! n.isDeleted) {
                    map.logger.info('从剪贴板粘贴', [n])
                    nodesToSelect.add(n)
                }
            })
        ))
    )

    map.selectNodes(nodesToSelect)
}

export const canPasteTreeAsAr = () => () => {
    return function (node) {
        if (! this.actions.canPasteTreeAppend(node)) {
            return false
        }

        // TODO
        return true
    }
}

export const pasteTreeAsAr = () => () => {
    return async function (nodes) {
        const insert = (node, child) => {
            if (node.lastChild) {
                let cursor = node.lastChild

                while (cursor) {
                    const _n = this.nodeProxy(cursor)

                    if (! _n.isHidden() && _n.canMove()) {
                        this.insertSiblingAfter(cursor, child)
                        return
                    }

                    cursor = cursor.prevSibling
                }

                this.prependChild(node, child)
            }
            else {
                this.appendChild(node, child)
            }
        }

        await pasteTree(this, nodes, insert)
    }
}
